module.exports = __webpack_public_path__ + "static/media/ipul-2.64be30e0.jpg";